import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 2500,
  timerProgressBar: true,
  background: '#e9ecef',
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});

export const showSuccess = (msg) => {
  Toast.fire({ icon: 'success', title: msg });
};

export const showError = (msg) => {
  Toast.fire({ icon: 'error', title: msg });
};

export default Toast;
